module.exports = __webpack_public_path__ + "static/media/realtalk_sd_nagia96a41ec2bd3f7ccc8bcdf2ae5c797d6.webp";